module.exports = __webpack_public_path__ + "img/1497341367.b4feff80.jpg";